import axios from "axios";
import { baseUrl } from '../../config/clientsConfig'

const InterestedTagService ={
    fetchInterestedTag: ()=>{
        return axios.get(`${baseUrl}/interestedTags`);
    },
    createInterestedTag: (name)=>{
        return axios.post(`${baseUrl}/interestedTag`, {name})
    },
    updateInterestedTag: (id, name)=>{
        return axios.put(`${baseUrl}/interestedTag`,{id,name})
    },
    bulkUploadInterestAndsources: (name, path)=>{
        return axios.post(`${baseUrl}/interet-source/bulk-upload/${path}`,name)
    }
}

export default InterestedTagService;